export function getReports({ selectedGroupID, data }) {
  // no group selected, which shouldn't happen
  if (!selectedGroupID) return [];

  // show only report boards
  if (selectedGroupID === "allreports") {
    return data?.reportBoards?.map((board) => {
      return {
        ID: board.boardID,
        name: board.boardName,
      };
    });
  }

  // selected group's boards
  return data?.groups.find((group) => group.ID === selectedGroupID).boards;
}

export function getSelectedBoardName({ selectedBoardID, data }) {
  // no board selected - it shouldn't hit this function in this case
  if (!selectedBoardID) return "";

  let reportBoardName = data?.reportBoards?.find(
    (board) => board.boardID === selectedBoardID
  )?.boardName;

  let groupBoardName = data?.groups?.reduce((acc, cur) => {
    // once there is found name, keep it
    if (acc) return acc;

    // save the found name
    let board = cur?.boards?.find((board) => board.ID === selectedBoardID);
    if (board) return board.name;

    // if no name is found, don't save anything
    return acc;
  }, "");

  return reportBoardName || groupBoardName;
}

export function getSelectedBoard({ selectedBoardID, selectedGroupID, data }) {
  const group = data.groups.find((group) => group.ID === selectedGroupID);
  const board = group.boards.find((board) => board.ID === selectedBoardID);
  return { groupSlug: group.groupSlug, boardSlug: board.slug };
}
